import type * as api from '@gitbook/api-client';
import type { Change, TextRange } from '@gitbook/slate';

import { createMention } from '../mention';
import { INLINE_LINK } from '../types';

/**
 * Insert a content reference at the current selection
 */
export function insertContentReference(change: Change, ref: api.ContentRef) {
    // @ts-expect-error
    return insertContentReferenceAtRange(change, ref, change.value.selection);
}

/**
 * Insert a content reference at a particular range to replace selected text or wrap an inline void with a link to the ref.
 */
export function insertContentReferenceAtRange(
    change: Change,
    contentRef: api.ContentRef,
    range: TextRange
) {
    if (change.value.isCollapsed && contentRef.kind === 'url') {
        change.insertTextAtRange(range, contentRef.url, []).extend(-contentRef.url.length).focus();
    }

    if (change.value.isCollapsed && !change.value.isInVoid) {
        change.insertInlineAtRange(range, createMention(contentRef)).focus();
    } else {
        change
            .wrapInline({
                type: INLINE_LINK,
                data: {
                    ref: contentRef,
                },
            })
            .collapseToEnd()
            .focus();
    }
}
